export const OutcomeOptions = ['WON', 'LOST', 'DELAYED', 'PO PENDING'];
